$(function () {
    $('.select-year').on('change', function () {
        const year = $(this).val();

        console.log(year)

        if (year != '') {
            $('table tbody tr').hide();
            $('table tbody tr[data-year="' + year + '"]').show();
        } else {
            $('table tbody tr').show();
        }
    });
});
